import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconChatError = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', ...other } = props;

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.4 14.001L12 11.401L14.6 14.001L16 12.601L13.4 10.001L16 7.40098L14.6 6.00098L12 8.60098L9.4 6.00098L8 7.40098L10.6 10.001L8 12.601L9.4 14.001ZM2 22.001V4.00098C2 3.45098 2.19583 2.98014 2.5875 2.58848C2.97917 2.19681 3.45 2.00098 4 2.00098H20C20.55 2.00098 21.0208 2.19681 21.4125 2.58848C21.8042 2.98014 22 3.45098 22 4.00098V16.001C22 16.551 21.8042 17.0218 21.4125 17.4135C21.0208 17.8051 20.55 18.001 20 18.001H6L2 22.001ZM5.15 16.001H20V4.00098H4V17.126L5.15 16.001Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconChatError.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconChatError;
